module.exports = __webpack_public_path__ + "static/img/wiseBrainIcon6.44991be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wiseBrainIcon6.png
// module id = zXiO
// module chunks = 1